var _desc, _style, _g, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _rect, _tspan0, _rect2, _tspan1, _polygon, _rect3, _tspan10, _tspan11, _rect4, _tspan12, _rect5, _tspan13, _tspan14, _tspan15, _tspan16, _polygon2, _rect6, _tspan17, _tspan18, _rect7, _tspan19, _rect8, _tspan20, _tspan21, _tspan22, _rect9, _tspan23, _tspan24, _tspan25, _tspan26, _defs, _defs2, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifecycle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "my-svg",
    width: 465.3671875,
    height: 1374.5999755859375,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "flowchart",
    style: {
      maxWidth: "465.367px",
      backgroundColor: "transparent"
    },
    viewBox: "4 4 465.3671875 1374.5999755859375",
    role: "graphics-document document",
    "aria-roledescription": "flowchart-v2",
    "aria-describedby": "chart-desc-my-svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, "Port-call lifecycle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "chart-desc-my-svg"
  }, "Submission requests review. Approval checks blockers and acknowledgements. Later attention does not change approved status.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "#my-svg{font-family:Arial,sans-serif;font-size:16px;fill:#20303a;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#my-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#my-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#my-svg .error-icon{fill:#ffffff;}#my-svg .error-text{fill:#000000;stroke:#000000;}#my-svg .edge-thickness-normal{stroke-width:1px;}#my-svg .edge-thickness-thick{stroke-width:3.5px;}#my-svg .edge-pattern-solid{stroke-dasharray:0;}#my-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#my-svg .edge-pattern-dashed{stroke-dasharray:3;}#my-svg .edge-pattern-dotted{stroke-dasharray:2;}#my-svg .marker{fill:#667684;stroke:#667684;}#my-svg .marker.cross{stroke:#667684;}#my-svg svg{font-family:Arial,sans-serif;font-size:16px;}#my-svg p{margin:0;}#my-svg .label{font-family:Arial,sans-serif;color:#20303a;}#my-svg .cluster-label text{fill:#000000;}#my-svg .cluster-label span{color:#000000;}#my-svg .cluster-label span p{background-color:transparent;}#my-svg .label text,#my-svg span{fill:#20303a;color:#20303a;}#my-svg .node rect,#my-svg .node circle,#my-svg .node ellipse,#my-svg .node polygon,#my-svg .node path{fill:#edf5f8;stroke:#2e718e;stroke-width:1px;}#my-svg .rough-node .label text,#my-svg .node .label text,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-anchor:middle;}#my-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#my-svg .rough-node .label,#my-svg .node .label,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-align:center;}#my-svg .node.clickable{cursor:pointer;}#my-svg .root .anchor path{fill:#667684!important;stroke-width:0;stroke:#667684;}#my-svg .arrowheadPath{fill:#0b0b0b;}#my-svg .edgePaths .path{stroke:#667684;stroke-width:1px;}#my-svg .flowchart-link{stroke:#667684;fill:none;}#my-svg .edgeLabel{background-color:#f8fafb;text-align:center;}#my-svg .edgeLabel p{background-color:#f8fafb;}#my-svg .edgeLabel rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .labelBkg{background-color:rgba(248, 250, 251, 0.5);}#my-svg .cluster rect{fill:#ffffff;stroke:hsl(0, 0%, 90%);stroke-width:1px;}#my-svg .cluster text{fill:#000000;}#my-svg .cluster span{color:#000000;}#my-svg .node .collapsed-indicator{fill:hsl(0, 0%, 90%);stroke:none;opacity:0.6;}#my-svg .node .collapsed-separator{stroke:hsl(0, 0%, 90%);stroke-width:0.75px;}#my-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:Arial,sans-serif;font-size:12px;background:#ffffff;border:1px solid hsl(0, 0%, 90%);border-radius:2px;pointer-events:none;z-index:100;}#my-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#20303a;}#my-svg rect.text{fill:none;stroke-width:0;}#my-svg .icon-shape,#my-svg .image-shape{background-color:#f8fafb;text-align:center;}#my-svg .icon-shape p,#my-svg .image-shape p{background-color:#f8fafb;padding:2px;}#my-svg .icon-shape .label rect,#my-svg .image-shape .label rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .label-icon{display:inline-block;height:1em;overflow:visible;vertical-align:-0.125em;}#my-svg .node .label-icon path{fill:currentColor;stroke:revert;stroke-width:revert;}#my-svg .node .neo-node{stroke:#2e718e;}#my-svg [data-look=\"neo\"].node rect,#my-svg [data-look=\"neo\"].cluster rect,#my-svg [data-look=\"neo\"].node polygon{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].swimlane.cluster rect{filter:none;}#my-svg [data-look=\"neo\"].node path{stroke:url(#my-svg-gradient);stroke-width:1px;}#my-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node .neo-line path{stroke:#2e718e;filter:none;}#my-svg [data-look=\"neo\"].node circle{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#my-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg :root{--mermaid-font-family:Arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 4.5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 5 L 10 10 L 10 0 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 11.5,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 10.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 11.5 7 L 0 14 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 1,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,7 11.5,14 11.5,0",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 11,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -1,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refY: 5,
    refX: 12.25,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -2,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: 12,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: -1,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: 17.7,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: -3.5,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edges edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184,53L184,150",
    id: "my-svg-L_A_B_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 93 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_A_B_0",
    "data-points": "W3sieCI6MTg0LCJ5Ijo1M30seyJ4IjoxODQsInkiOjE1NH1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,195L184,231",
    id: "my-svg-L_B_C_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_B_C_0",
    "data-points": "W3sieCI6MTg0LCJ5IjoxOTV9LHsieCI6MTg0LCJ5IjoyMzV9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56666564941406,392.1666659821494L156.56666564941406,419.6000061035156L156.56666564941406,432.52893829165015Q156.56666564941406,439.6000061035156 149.4955978375486,439.6000061035156L95.07106781186548,439.6000061035156Q88,439.6000061035156 88,446.6710739153811L88,516.6000061035156",
    id: "my-svg-L_C_D_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 183.67178344726562 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_C_D_0",
    "data-points": "W3sieCI6MTU2LjU2NjY2NTY0OTQxNDA2LCJ5IjozOTIuMTY2NjY1OTgyMTQ5NH0seyJ4IjoxNTYuNTY2NjY1NjQ5NDE0MDYsInkiOjQxOS42MDAwMDYxMDM1MTU2fSx7IngiOjE1Ni41NjY2NjU2NDk0MTQwNiwieSI6NDM5LjYwMDAwNjEwMzUxNTZ9LHsieCI6ODgsInkiOjQzOS42MDAwMDYxMDM1MTU2fSx7IngiOjg4LCJ5Ijo1MjAuNjAwMDA2MTAzNTE1Nn1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.43333435058594,392.1666659821494L211.43333435058594,419.6000061035156L211.43333435058594,432.52893829165015Q211.43333435058594,439.6000061035156 218.5044021624514,439.6000061035156L272.9289321881345,439.6000061035156Q280,439.6000061035156 280,446.6710739153811L280,516.6000061035156",
    id: "my-svg-L_C_E_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 183.6717529296875 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_C_E_0",
    "data-points": "W3sieCI6MjExLjQzMzMzNDM1MDU4NTk0LCJ5IjozOTIuMTY2NjY1OTgyMTQ5NH0seyJ4IjoyMTEuNDMzMzM0MzUwNTg1OTQsInkiOjQxOS42MDAwMDYxMDM1MTU2fSx7IngiOjIxMS40MzMzMzQzNTA1ODU5NCwieSI6NDM5LjYwMDAwNjEwMzUxNTZ9LHsieCI6MjgwLCJ5Ijo0MzkuNjAwMDA2MTAzNTE1Nn0seyJ4IjoyODAsInkiOjUyMC42MDAwMDYxMDM1MTU2fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,614.4000091552734L280,650.4000091552734",
    id: "my-svg-L_E_F_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_E_F_0",
    "data-points": "W3sieCI6MjgwLCJ5Ijo2MTQuNDAwMDA5MTU1MjczNH0seyJ4IjoyODAsInkiOjY1NC40MDAwMDkxNTUyNzM0fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.56666564941406,811.5666751374229L252.56666564941406,839.0000152587891L252.56666564941406,851.9289474469235Q252.56666564941406,859.0000152587891 245.4955978375486,859.0000152587891L182.25856781186548,859.0000152587891Q175.1875,859.0000152587891 175.1875,866.0710830706546L175.1875,889.5000152587891L175.1875,1075.5000114440918L175.1875,1107.7289428692868Q175.1875,1114.8000106811523 182.25856781186548,1114.8000106811523L250.92893218813452,1114.8000106811523Q258,1114.8000106811523 258,1121.8710784930179L258,1130.8000106811523",
    id: "my-svg-L_F_G_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 464.76849365234375 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_F_G_0",
    "data-points": "W3sieCI6MjUyLjU2NjY2NTY0OTQxNDA2LCJ5Ijo4MTEuNTY2Njc1MTM3NDIyOX0seyJ4IjoyNTIuNTY2NjY1NjQ5NDE0MDYsInkiOjgzOS4wMDAwMTUyNTg3ODkxfSx7IngiOjI1Mi41NjY2NjU2NDk0MTQwNiwieSI6ODU5LjAwMDAxNTI1ODc4OTF9LHsieCI6MTc1LjE4NzUsInkiOjg1OS4wMDAwMTUyNTg3ODkxfSx7IngiOjE3NS4xODc1LCJ5Ijo4ODkuNTAwMDE1MjU4Nzg5MX0seyJ4IjoxNzUuMTg3NSwieSI6MTA3NS41MDAwMTE0NDQwOTE4fSx7IngiOjE3NS4xODc1LCJ5IjoxMTE0LjgwMDAxMDY4MTE1MjN9LHsieCI6MjU4LCJ5IjoxMTE0LjgwMDAxMDY4MTE1MjN9LHsieCI6MjU4LCJ5IjoxMTM0LjgwMDAxMDY4MTE1MjN9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43333435058594,811.5666751374229L307.43333435058594,839.0000152587891L307.43333435058594,851.9289474469235Q307.43333435058594,859.0000152587891 314.5044021624514,859.0000152587891L377.7414321881345,859.0000152587891Q384.8125,859.0000152587891 384.8125,866.0710830706546L384.8125,936.0000152587891",
    id: "my-svg-L_F_H_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 192.4842071533203 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_F_H_0",
    "data-points": "W3sieCI6MzA3LjQzMzMzNDM1MDU4NTk0LCJ5Ijo4MTEuNTY2Njc1MTM3NDIyOX0seyJ4IjozMDcuNDMzMzM0MzUwNTg1OTQsInkiOjgzOS4wMDAwMTUyNTg3ODkxfSx7IngiOjMwNy40MzMzMzQzNTA1ODU5NCwieSI6ODU5LjAwMDAxNTI1ODc4OTF9LHsieCI6Mzg0LjgxMjUsInkiOjg1OS4wMDAwMTUyNTg3ODkxfSx7IngiOjM4NC44MTI1LCJ5Ijo5NDAuMDAwMDE1MjU4Nzg5MX1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8125,1016.2000122070312L384.8125,1107.7289428692868Q384.8125,1114.8000106811523 377.7414321881345,1114.8000106811523L309.0710678118655,1114.8000106811523Q302,1114.8000106811523 302,1121.8710784930179L302,1130.8000106811523",
    id: "my-svg-L_H_G_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 188.08421325683594 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_H_G_0",
    "data-points": "W3sieCI6Mzg0LjgxMjUsInkiOjEwMTYuMjAwMDEyMjA3MDMxMn0seyJ4IjozODQuODEyNSwieSI6MTExNC44MDAwMTA2ODExNTIzfSx7IngiOjMwMiwieSI6MTExNC44MDAwMTA2ODExNTIzfSx7IngiOjMwMiwieSI6MTEzNC44MDAwMTA2ODExNTIzfV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,1175.8000106811523L280,1272.8000106811523",
    id: "my-svg-L_G_I_0",
    className: "edge-thickness-normal edge-pattern-dotted edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 2 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_G_I_0",
    "data-points": "W3sieCI6MjgwLCJ5IjoxMTc1LjgwMDAxMDY4MTE1MjN9LHsieCI6MjgwLCJ5IjoxMjc2LjgwMDAxMDY4MTE1MjN9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(183.5234375, 103.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_A_B_0",
    transform: "translate(-0.21875, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -63.8046875,
    y: 0,
    width: 128.046875,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Submit"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " for"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " review"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(87.953125, 470.1000061035156)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_C_D_0",
    transform: "translate(-0.2734375, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -24.6796875,
    y: 0,
    width: 49.90625,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Reject"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(279.84765625, 470.1000061035156)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_C_E_0",
    transform: "translate(0.44921875, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -32.796875,
    y: 0,
    width: 64.6953125,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Approve"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(174.75, 978.1000137329102)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_F_G_0",
    transform: "translate(0, -19.299999237060547)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -94.0625,
    y: 0,
    width: 188.125,
    height: 38.599998474121094
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "None;"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " acknowledgements"))), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "complete"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(384.60546875, 889.5000152587891)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_F_H_0",
    transform: "translate(-0.05078125, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -40.2421875,
    y: 0,
    width: 80.5859375,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Remaining"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(384.58984375, 1075.5000114440918)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_H_G_0",
    transform: "translate(-0.05078125, -19.299999237060547)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -76.7265625,
    y: 0,
    width: 153.5546875,
    height: 38.599998474121094
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Required"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " reason"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " and"))), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "snapshot"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(279.98046875, 1226.3000106811523)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_G_I_0",
    transform: "translate(-0.33203125, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -65.1484375,
    y: 0,
    width: 130.9609375,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Later"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " new"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " blocker")))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-A-0",
    "data-look": "neo",
    transform: "translate(184, 32.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -20.5,
    width: 152,
    height: 41
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -8.5)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Draft"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-B-1",
    "data-look": "neo",
    transform: "translate(184, 174.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -20.5,
    width: 152,
    height: 41
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -8.5)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Submitted"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-C-3",
    "data-look": "neo",
    transform: "translate(184, 327.3000030517578)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "92.29999923706055,0 184.5999984741211,-92.29999923706055 92.29999923706055,-184.5999984741211 0,-92.29999923706055",
    className: "label-container",
    transform: "translate(-91.79999923706055, 92.29999923706055)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Reviewer"))), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "decision"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-D-5",
    "data-look": "neo",
    transform: "translate(88, 541.1000061035156)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -20.5,
    width: 152,
    height: 41
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -8.5)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Rejected"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-E-7",
    "data-look": "neo",
    transform: "translate(280, 567.5000076293945)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -46.900001525878906,
    width: 152,
    height: 93.80000305175781
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -34.900001525878906)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Recompute"))), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "checks"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " and"))), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "acknowledgeme"))), _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "3.2em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "nts"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-F-9",
    "data-look": "neo",
    transform: "translate(280, 746.7000122070312)"
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "92.29999923706055,0 184.5999984741211,-92.29999923706055 92.29999923706055,-184.5999984741211 0,-92.29999923706055",
    className: "label-container",
    transform: "translate(-91.79999923706055, 92.29999923706055)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Blocking"))), _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "conflicts?"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-G-11",
    "data-look": "neo",
    transform: "translate(280, 1155.3000106811523)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -20.5,
    width: 152,
    height: 41
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -8.5)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Approved"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-H-13",
    "data-look": "neo",
    transform: "translate(384.8125, 978.1000137329102)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Correct"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " inputs"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " or"))), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "authorized"))), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "override"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-I-17",
    "data-look": "neo",
    transform: "translate(280, 1323.7000122070312)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -46.900001525878906,
    width: 152,
    height: 93.80000305175781
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -34.900001525878906)"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Attention"))), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "required;"))), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "approval"))), _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "3.2em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "preserved")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow",
    height: "130%",
    width: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 4,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow-small",
    height: "150%",
    width: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "my-svg-gradient",
    gradientUnits: "objectBoundingBox",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2e718e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "hsl(200, 0%, 87.8431372549%)",
    stopOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifecycle);
export default __webpack_public_path__ + "static/media/lifecycle.4b7e9690397c9999240d997fd6a4d853.svg";
export { ForwardRef as ReactComponent };